export type TaskListTemplateModel = {
  cache_key: number,
  data?: object,
  hidden?: boolean,
  id: number,
  owner_id?: number,
  owner_type?: string,
  template_checklist?: boolean,
  title: string,
  user_id?: number,
  workflow?: boolean,
}

export type TaskListTemplateRequestOptions = {}

const state = {
  data: {},
  hidden: false,
  id: null,
  owner_id: undefined,
  owner_type: undefined,
  template_checklist: false,
  title: '',
  user_id: undefined,
  workflow: false,
}

export const requiredFields = [
  { key: 'owner_id', validation: (value, entityState) => entityState.owner_type === 'System' || !!value },
  { key: 'owner_type' },
  { key: 'title' },
]

export default state
